import { Injectable } from '@angular/core';
import { MangoQuery, RxCollection } from 'rxdb';
import { RxdbInitializerService } from './rxdb-initializer.service';

@Injectable({
    providedIn: 'root'
})
export abstract class DbBaseProviderService {
    protected currentCollection: Promise<RxCollection | null>;
    private static currentUserId: string;

    public static getCurrentUserId() {
        return DbBaseProviderService.currentUserId;
    };

    public static setCurrentUserId(userId: string): string {
        return DbBaseProviderService.currentUserId = userId || 'public'; // public for public user
    };

    protected filterFn(item: any): boolean {
        if (item === null || item === undefined) {
            return false;
        }

        if (item.userId && DbBaseProviderService.currentUserId && item.userId != DbBaseProviderService.currentUserId) {
            return false;
        }

        return true;
    }

    protected async remove<T>(collection: Promise<RxCollection>, query: MangoQuery<any>): Promise<T[]> {
        let removeResult = await (<RxCollection>(await collection))
            .find(query)
            .remove();
        await (<RxCollection>(await collection)).cleanup(0);

        return removeResult;
    }

    protected async findItems<T>(collection: Promise<RxCollection>, query: MangoQuery<any>): Promise<T[]> {
        var docs = await (<RxCollection>(await collection))
            .find(query)
            .exec();

        var items: T[] = [];
        for (var i = 0; i < docs.length; i++) {
            if (!this.filterFn(docs[i]._data)) {
                continue;
            }

            items.push(JSON.parse(JSON.stringify(docs[i]._data)));
        }

        return items;
    }

    protected async findByIds<T>(collection: Promise<RxCollection>, ids: string[]): Promise<T[]> {
        var docs = await (<RxCollection>(await collection))
            .findByIds(ids)
            .exec();

        var items: T[] = [];
        for (let entry of docs) {
            if (!this.filterFn(entry[1]._data)) {
                continue;
            }

            items.push(JSON.parse(JSON.stringify(entry[1]._data)));
        }

        return items;
    }

    protected async findFirstItem<T>(method: () => Promise<T[]>): Promise<T | null> {
        var items = await method();
        if (items.length <= 0) {
            return null;
        }

        return this.filterFn(items[0]) ? items[0] : null;
    }

    public async removeByProductId(prodId: string): Promise<any[]> {
        let filter: MangoQuery<any> = {
            selector: {
                $and: [
                    {
                        formId: prodId,
                    }
                ]
            }
        };

        return await this.remove(this.currentCollection, filter);
    }
}
